import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NgxEchartsModule} from 'ngx-echarts';
import * as echarts from 'echarts';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FlexLayoutModule} from '@angular/flex-layout';
import {HeaderComponent} from './shared/UI/header/header.component';

import {HomeComponent} from './core/home/home.component';

import {OlMapComponent} from './shared/ol-map/ol-map.component';
import {CountriesListComponent} from './shared/countries/countries-list/countries-list.component';
import {OlMapDirective} from './shared/ol-map/services/ol-map.directive';
import {CountryDetailsComponent} from './shared/countries/country-details/country-details.component';
import {ChartViewComponent} from './core/chart-view/chart-view.component';
import {ChartsModule} from 'ng2-charts';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ErrorComponent} from './shared/error/error.component';
import {ErrorHandlerService} from './shared/error/error-handler.service';
import {MapCountryDialogComponent} from './shared/dialogs/map-mat-dialog/map-country-dialog.component';
import {ChartComponentsModule} from './shared/chart-components.module';
import {DataCardComponent} from './shared/UI/data-card/data-card.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatIconModule} from '@angular/material/icon';
import {MatTableModule} from '@angular/material/table';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatListModule} from '@angular/material/list';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatButtonModule} from '@angular/material/button';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {SidenavListComponent} from './shared/UI/sidenav-list/sidenav-list.component';
import {MatTooltipModule} from '@angular/material/tooltip';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    OlMapComponent,
    CountriesListComponent,
    CountryDetailsComponent,
    OlMapDirective,
    ChartViewComponent,
    ErrorComponent,
    MapCountryDialogComponent,
    DataCardComponent,
    SidenavListComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    ChartsModule,
    ChartComponentsModule,
    NgxEchartsModule.forRoot({echarts}),
    MatSnackBarModule,
    MatIconModule,
    MatTableModule,
    MatSlideToggleModule,
    MatListModule,
    MatDialogModule,
    MatInputModule,
    MatProgressBarModule,
    MatButtonModule,
    MatSidenavModule,
    MatToolbarModule,
    MatTooltipModule
  ],
  providers: [{provide: ErrorHandler, useClass: ErrorHandlerService}],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {
}
